export default {
  DisplayHide: 'Ẩn/ hiện báo cáo',
  Quantity: 'Số lượng:',
  Displaying: 'báo cáo đang hiển thị',
  Cancel: 'Hủy',
  Save: 'Lưu',
  PeriodReport: 'Kỳ báo cáo',
};
